module.exports = __webpack_public_path__ + "static/media/East_Hall.8c34432b.webp";